import { render, staticRenderFns } from "./wlBanner.vue?vue&type=template&id=8715d93c&scoped=true&"
import script from "./wlBanner.vue?vue&type=script&lang=js&"
export * from "./wlBanner.vue?vue&type=script&lang=js&"
import style0 from "./wlBanner.vue?vue&type=style&index=0&id=8715d93c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8715d93c",
  null
  
)

export default component.exports